export const escapeCSVValue = (value) => {
  if (value === null || value === undefined) return "";
  const stringValue = String(value);
  if (stringValue.includes(",") || stringValue.includes('"') || stringValue.includes("\n")) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue ?? "--";
};

export const downloadCSV = (data, filename = "sample.csv") => {
  if (!data.length) return;

  const headers = Object.keys(data[0]).join(",") + "\n"; // Get CSV headers
  const rows = data.map((obj) => Object.values(obj).join(",")).join("\n"); // Convert each object to a CSV row
  const csvString = headers + rows;

  // Create a Blob and trigger download
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const imageUrlToFile = async (url, filename, mimeType) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: mimeType });
};

export const appendSizeToFilename = (file) => {
  const sizeInKB = Math.round(file.size / 1024);
  const [name, ...extParts] = file.name.split(".");
  const extension = extParts.pop();
  const baseName = [name, ...extParts].join(".");

  const newName = `${baseName}_${sizeInKB}KB.${extension}`;
  return new File([file], newName, { type: file.type });
};
